import React, { FC } from 'react'
import { DispatchBanner } from '@moonpig/web-shared-products'
import { useExperiment } from '@moonpig/web-core-experiments'
import { useProductContext } from '../../../contexts/product'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'
import { hasProductVideo } from '../../../utils/getProductVideoId'

export const DispatchCutOffBannerModule: FC<ProductModule> = props => {
  const [{ product, departmentInfo }] = useProductContext()

  const attachProductVideoEnabled =
    useExperiment('attach-product-video') === 'enabled' &&
    hasProductVideo(product.id)

  return (
    <>
      {!attachProductVideoEnabled && (
        <ProductModuleSection {...props}>
          <DispatchBanner
            dispatchCutOff={departmentInfo?.dispatchCutOff}
            py={4}
            px={6}
            borderRadius={1}
          />
        </ProductModuleSection>
      )}
    </>
  )
}
